import React from 'react';
import { Input } from '../../ui/Input';
import { Button } from '../../ui/Button';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../../common/SafeIcon';

export const TabLinks = ({ links, setLinks }) => {
  const addLink = () => {
    setLinks([...links, { platform: 'custom', title: '', url: '', is_visible: true }]);
  };

  const updateLink = (index, field, value) => {
    const newLinks = [...links];
    newLinks[index][field] = value;
    setLinks(newLinks);
  };

  const removeLink = (index) => {
    setLinks(links.filter((_, i) => i !== index));
  };

  const moveLink = (index, direction) => {
    if (direction === -1 && index === 0) return;
    if (direction === 1 && index === links.length - 1) return;
    const newLinks = [...links];
    const temp = newLinks[index];
    newLinks[index] = newLinks[index + direction];
    newLinks[index + direction] = temp;
    setLinks(newLinks);
  };

  return (
    <div className="space-y-6">
      <Button variant="secondary" onClick={addLink} className="w-full py-4 border-dashed border-2">
        <SafeIcon icon={FiIcons.FiPlus} className="mr-2" /> Add New Link
      </Button>

      <div className="space-y-4">
        {links.map((link, idx) => (
          <div key={idx} className="bg-slate-50 p-5 rounded-xl border border-slate-200 flex flex-col gap-4">
            <div className="flex flex-col sm:flex-row gap-3">
               <Input 
                 placeholder="Label (e.g. LinkedIn)" 
                 value={link.title} 
                 onChange={e => updateLink(idx, 'title', e.target.value)} 
                 className="flex-1" 
               />
               <Input 
                 placeholder="URL (https://...)" 
                 value={link.url} 
                 onChange={e => updateLink(idx, 'url', e.target.value)} 
                 className="flex-1" 
               />
            </div>
            <div className="flex justify-between items-center pt-2">
               <label className="flex items-center space-x-2 cursor-pointer">
                  <input 
                    type="checkbox" 
                    checked={link.is_visible} 
                    onChange={e => updateLink(idx, 'is_visible', e.target.checked)} 
                    className="rounded border-slate-300 w-5 h-5 text-slate-900 focus:ring-slate-900" 
                  />
                  <span className="text-sm font-medium text-slate-700">Visible on card</span>
               </label>
               <div className="flex gap-2">
                  <button onClick={() => moveLink(idx, -1)} disabled={idx === 0} className="p-2 bg-white rounded border text-slate-400 hover:text-slate-900 disabled:opacity-30">
                    <SafeIcon icon={FiIcons.FiArrowUp} />
                  </button>
                  <button onClick={() => moveLink(idx, 1)} disabled={idx === links.length - 1} className="p-2 bg-white rounded border text-slate-400 hover:text-slate-900 disabled:opacity-30">
                    <SafeIcon icon={FiIcons.FiArrowDown} />
                  </button>
                  <button onClick={() => removeLink(idx)} className="p-2 bg-white rounded border text-red-400 hover:text-red-600 hover:border-red-200 ml-2">
                    <SafeIcon icon={FiIcons.FiTrash2} />
                  </button>
               </div>
            </div>
          </div>
        ))}
        {links.length === 0 && (
          <p className="text-center text-slate-500 py-8 bg-slate-50 rounded-xl border border-slate-100 border-dashed">
            No links added yet. Share your social media or portfolio.
          </p>
        )}
      </div>
    </div>
  );
};